import { EVENT_CLICK, FIREBASE, SCREENNAME_NAMELESS_CARDS_LIST } from '@globalConstants';

export const EVENT_NAMELESS_CARDS_DETAIL = 'namelessCardsList_detail';
export const EVENT_NAMELESS_CARDS_GO_BACK = 'namelessCardsList_goBack';

export const NAMELESS_CARDS_DETAIL_CLICK_EVENT = [
  {
    type: FIREBASE,
    name: EVENT_CLICK,
    props: {
      screen_name: SCREENNAME_NAMELESS_CARDS_LIST,
      element: EVENT_NAMELESS_CARDS_DETAIL,
    },
  },
];

export const NAMELESS_CARDS_GO_BACK_CLICK_EVENT = [
  {
    type: FIREBASE,
    name: EVENT_CLICK,
    props: {
      screen_name: SCREENNAME_NAMELESS_CARDS_LIST,
      element: EVENT_NAMELESS_CARDS_GO_BACK,
    },
  },
];
